function getTime(date){
  let h = date.getHours();
  let m = date.getMinutes();
  return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
}

export const timeago = function(d, _default = null){
  if (!d) return _default;

  let date = new Date(d);
  let now = new Date();
  let seconds = (now.getTime() - date.getTime()) / 1000;

  if (seconds <= 20) {
    return 'Just a moment';
  }

  // Less then minutes
  if (seconds <= 60) {
    return Math.floor(seconds) + 's ago';
  }

  // Less then hours
  if (seconds < 3600) {
    return Math.floor(seconds / 60) + 'm ago';
  }

  // Check if is yesterday
  let yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toLocaleDateString() === yesterday.toLocaleDateString()) {
    return 'Yesterday, at ' + getTime(date);
  }

  // Less then day
  if (seconds < 86400) {
    return Math.floor(seconds / 3600) + 'h ago';
  }

  // Less week
  if (seconds < 604800) {
    return Math.floor(seconds / 86400) + 'd ago';
  }

  // Less month
  if (seconds < 2419200) {
    return Math.floor(seconds / 604800) + 'w ago';
  }

  if (now.getFullYear() === date.getFullYear()) {
    return date.getDate() + '/' + (date.getMonth() + 1) + ' at ' + getTime(date);
  }

  return date.getDate() + '/' + (date.getMonth() + 1) + ', ' + date.getFullYear();
}

export const fullTime = function(d){
  let date = new Date(d);
  let days = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'];

  return days[date.getDay()] + ', ngày ' + date.getDate() + ' tháng ' + (date.getMonth() + 1) + ', ' + date.getFullYear() + ' lúc ' + getTime(date);
}

export const shortDate = function(value){
  let d = new Date(value);
  let month = ['Januaray', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  return month[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
}
